var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LazyUIAlertBox',{attrs:{"color":"honey"}},[_vm._v("\n  We are having trouble fetching the latest billing information from\n  "+_vm._s(_vm.billingBackendHandler)+". Please check your "+_vm._s(_vm.billingBackendHandler)+" billing page for\n  recent updates.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }